if (navigator.geolocation && document.body.classList.contains('boxsprings-template-default')) {
    navigator.geolocation.getCurrentPosition(function(position) {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;

        if  (latitude && longitude) {
            jQuery.post(ajax_object.ajax_url, {
                action: 'save_user_location',
                latitude: latitude,
                longitude: longitude
            });
        }
    });
}
